export default "__VITE_ASSET__BSbma$p2__"